import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuthContext } from "@/contexts/AuthContext";
import { useState } from "react";

interface ForgotPasswordModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onBackToLogin?: () => void;
}

export const ForgotPasswordModal = ({ open, onOpenChange, onBackToLogin }: ForgotPasswordModalProps) => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { resetPasswordForEmail } = useAuthContext();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    
    const result = await resetPasswordForEmail(email);
    
    setIsLoading(false);
    
    if (!result.error) {
      setEmail("");
      setTimeout(() => {
        onOpenChange(false);
        onBackToLogin?.();
      }, 2000);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md p-0 bg-white rounded-2xl">
        <div className="p-8">
          <DialogHeader className="text-center mb-8">
            <DialogTitle className="text-2xl font-semibold text-dark-blue">
              Återställ lösenord
            </DialogTitle>
            <p className="text-sm text-gray-600 mt-2">
              Ange din e-postadress så skickar vi en återställningslänk
            </p>
          </DialogHeader>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-sm font-medium text-gray-700">
                E-postadress
              </Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-[#5a8a8a] focus:ring-0"
                placeholder="din@epost.se"
                required
                disabled={isLoading}
              />
            </div>

            <Button
              type="submit"
              className="w-full py-3 rounded-full bg-[#5a8a8a] hover:bg-[#4a7a7a] text-white font-medium"
              disabled={isLoading}
            >
              {isLoading ? "Skickar..." : "Skicka återställningslänk"}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <button
              type="button"
              onClick={() => {
                onOpenChange(false);
                onBackToLogin?.();
              }}
              className="text-sm text-[#5a8a8a] hover:underline"
            >
              ← Tillbaka till inloggning
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
